import * as Period from '../../../../constants/Period';
var BIATHLON_PERIOD_MAP = {};
BIATHLON_PERIOD_MAP[2000] = Period.FIRST;
BIATHLON_PERIOD_MAP[2002] = Period.FIRST;
BIATHLON_PERIOD_MAP[2004] = Period.SECOND;
BIATHLON_PERIOD_MAP[2006] = Period.THIRD;
BIATHLON_PERIOD_MAP[2008] = Period.FOURTH;
BIATHLON_PERIOD_MAP[2010] = Period.FIFTH;
BIATHLON_PERIOD_MAP[2012] = Period.SIXTH;
BIATHLON_PERIOD_MAP[2014] = Period.SEVENTH;
BIATHLON_PERIOD_MAP[2016] = Period.EIGHTH;
BIATHLON_PERIOD_MAP[2017] = Period.FINISHED;
export default BIATHLON_PERIOD_MAP;



// WEBPACK FOOTER //
// ./src/components/grid/sportGlossary/Biathlon/PeriodMap.js